module.exports = __webpack_public_path__ + "static/img/icon_train.d69e0a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boss-home/icon_train.png
// module id = 8Oyn
// module chunks = 1